import {HttpException} from "./http.exception.js";

/**
 * 504 Gateway Timeout Exception
 */
export class GatewayTimeoutException extends HttpException {
    constructor(message: string = "Gateway Timeout", errorBody?: unknown, cause?: Error) {
        super(504, message, errorBody, cause);
    }
}
